module.exports = __webpack_public_path__ + "static/media/cov-19-vacc-book.b7969d5b.png";